import { isProduction } from "@/helpers/global/env.func";

export const config = {
  company: 'eif',
  market: 'hk',
  locale: 'hk',
  version: 'itrade7.5-v7.0.8',
  company_title: 'company_title',
  language: ['zh_TW', 'zh_CN', 'en_US'],
  routerPrefix: isProduction() ? (window.config?.webPath && `/${window.config.webPath}` || '') : '',
  defaultLanguage: isProduction() ? window.config?.defaultLanguage : 'zh_CN',
  thirdPartyLink: '',
  checkTabs: true,
  apis: {
    winvestorApi: true,
    mdsApi: true,
  },
  actions: {
    trading: {
      market_label: true,
    },
  },
  layouts: {
    fullLayout: {
      logoImgName: 'logo_dark.png',
    },
    mainLayout: {
      logoImgName: 'logo_dark.png',
    }
  },
  pages: {
    login: {
      ctrl: { securityTips: true },
      resetpassword: true
    },
    trade: {
      rewrite: false,
      ctrl: {
        searchDropdown: true
      },
      usePrePost: true,
      atAuctionBuy: true,
      orderEnquiry: {
        autoRefresh: {
          refreshTime: isProduction() ? (window.config?.companyOptions?.trading?.autoRefreshOrderEnquiry) : 5000,
          refreshSession: isProduction() ? (window.config?.companyOptions?.trading?.refreshSession) : false,
          checkSessionTime: isProduction() ? (window.config?.companyOptions?.trading?.autoCheckSession) : 300000
        }
      }
    },
    market: {
      init: { isOpenChart: true },
      ctrl: { orderDialog: true }
    },
    fundManagement: {
      fundTransfer: {
        queryCurrencyConversion: true
      },
      fundTransferEnquiry: {
        foreignExchangeEnquiry: true
      }
    },
    ipo: {
      margin: {
        disableCancel: true
      }
    }
  },
  constants: {
    winVest: {
      winvestorDeviceID: 'itrade7.5-web-eif',
    },
    apiEnv: {
      itradeAPI: location.origin,
      itradePath: '',

      MDSStreamingAPI: '',
      MDSSnapshotAPI: 'wss:/ttl2aacloud01.tx-tech.com/snapshot',
      MDSOthersAPI: '',
      MDSPath: '',
      MDSProxyAPI: '',
      MDSEntityKey: 'EIF',
      MDSSuperkey: 'eifhk2txtech1keyencrypt20key0729',

      winvestorAPI: location.origin,
      winvestorPath: 'eif/api',

      // Portfolio refresh after Para change
      portfolioRefreshAfterParaChangeMs: 2000,
      portfolioRefreshAfterParaChangeAttempts: 1,

      popupIPRestrictedMsg: false
    }
  }
}